export const GIFTED_ACCESS_TOKEN = 'giftedAccessToken';
